import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Commands, Results } from '@local/client-contracts';
import { HighlightStyle } from '@shared/pipes';
import { HubService } from 'src/app/bar/services/hub.service';

@Component({
  selector: 'result-annotation',
  templateUrl: './result-annotation.component.html',
  styleUrls: ['./result-annotation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultAnnotationComponent implements OnInit {
  private readonly MAX_CHARACTER_ON_LINE = 300;
  private _model: Results.Annotation;
  private breakLine = false;
  private text = '';
  highlightStyle: HighlightStyle = 'default';
  items: Results.RichTextSectionElement[] = [];

  @Input() highlights: Array<string>;
  @Input() set model(val: Results.Annotation) {
    this._model = val;
    this.initLink();
  }
  @Output() invoke = new EventEmitter<Commands.Command>();

  get model(): Results.Annotation {
    return this._model;
  }

  constructor(private hubService: HubService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
  }


  private initLink(): void {
    this.items = [];
    this.model.elements[0]?.elements?.find((element: Results.RichTextElement) => {
      if (element.type === 'rich_text_list' && this.isBreakLineList(element as Results.RichTextList)) return true;
      if (this.isBreakLine(element)) return true;
      if (this.text.length > this.MAX_CHARACTER_ON_LINE) return true;
    });
    this.addItems(null, true);
    this.cdr.markForCheck();
  }

  private isBreakLineList(list: Results.RichTextList): boolean {
    if (!list) return;
    const typeList = list.style === 'ordered' ? '1. ' : '• ';
    this.text += typeList;
    this.isBreakLineSection(list.elements[0]);
    return true;
  }

  private isBreakLine(element: Results.RichTextElement): boolean {
    switch (element.type) {
      case 'rich_text_section':
        return this.isBreakLineSection(element as Results.RichTextSection);
      case 'rich_text_quote':
        return this.isBreakLineSection(element as Results.RichTextQuote);
      case 'rich_text_preformatted':
        return this.isBreakLineSection(element as Results.RichTextPreformatted);
    }
    return false;
  }

  private isBreakLineSection(item: Results.RichTextQuote | Results.RichTextPreformatted | Results.RichTextSection): boolean {
    if (!item) return false;
    let breakLine: boolean;
    item.elements.find((element) => {
      breakLine = this.isBreakLineSectionElement(element);
      return breakLine;
    });
    return breakLine;
  }

  private isBreakLineSectionElement(element: Results.RichTextSectionElement): boolean {
    if (element.type === 'text') {
      return this.isBreakLineText(element as Results.RichTextText);
    }
    this.addItems(element);
    return false;
  }

  private isBreakLineText(element: Results.RichTextText): boolean {
    if (!element || element.type != 'text') return false;
    const firstLine = this.getFirstLine(element?.text);
    this.text += firstLine + ' ';
    if (firstLine.length != element?.text.length || firstLine.length > this.MAX_CHARACTER_ON_LINE) {
      this.breakLine = true;
      return true;
    }
    return false;
  }

  private addItems(item: Results.RichTextSectionElement, endLine = false): void {
    if (this.text) {
      if (endLine) {
        this.text = this.text.trimEnd() + (this.breakLine ? '...' : '');
      }
      this.items.push({
        text: this.text,
        type: 'text',
      } as Results.RichTextText);
      this.text = '';
    }
    if (item) {
      this.items.push({ ...item }, {
        text: ' ',
        type: 'text',
      } as Results.RichTextText);
    }
    if (endLine && (this.items[this.items.length - 1] as Results.RichTextText)?.text === ' ') {
      this.items.pop();
    }
  }

  private getFirstLine(text: string): string {
    return text?.split('\n')[0];
  }

  onInvoke(): void {
    if (!this.model.onClick) return;
    this.invoke.emit(this.model.onClick);
  }
}
